document.addEventListener('DOMContentLoaded', function() {
  // Initialize product card galleries that are already structured in the HTML via Liquid
  initProductCardGalleries();
});

function initProductCardGalleries() {
  // Add CSS for the swiper first to minimize FOUC (Flash of Unstyled Content)
  addSwiperStyles();
  
  // Find all product card swipers that were created in Liquid
  const productCardSwipers = document.querySelectorAll('.product-card-swiper-container');
  
  productCardSwipers.forEach(swiperContainer => {
    // Get the product URL from a data attribute
    const productUrl = swiperContainer.getAttribute('data-product-url');
    
    // Create a wrapper anchor element for right-click functionality
    wrapSwiperInAnchor(swiperContainer, productUrl);
    
    // Initialize Swiper for each container
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      autoHeight: false,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: swiperContainer.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: swiperContainer.querySelector('.swiper-button-next'),
        prevEl: swiperContainer.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        // Mobile view (show pagination, hide arrows)
        320: {
          navigation: {
            enabled: false,
          },
          pagination: {
            enabled: true,
          }
        },
        // Desktop view (show arrows, hide pagination)
        768: {
          navigation: {
            enabled: true,
          },
          pagination: {
            enabled: false,
          }
        }
      },
      on: {
        init: function() {
          // Show navigation elements after Swiper is initialized
          const navElements = swiperContainer.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination');
          navElements.forEach(el => {
            el.removeAttribute('style');
            el.classList.add('swiper-nav-initialized');
          });
        }
      }
    });
    
    // Prevent navigation when clicking on swiper controls
    preventNavigationOnControls(swiperContainer);
  });
}

function wrapSwiperInAnchor(swiperContainer, productUrl) {
  // Only proceed if we have a valid product URL and the container isn't already wrapped
  if (!productUrl || swiperContainer.parentElement.tagName === 'A') return;
  
  // Create the anchor element
  const anchor = document.createElement('a');
  anchor.href = productUrl;
  anchor.classList.add('product-card-link');
  anchor.style.display = 'block';
  anchor.style.textDecoration = 'none';
  anchor.style.color = 'inherit';
  
  // Insert the anchor before the swiper container
  swiperContainer.parentNode.insertBefore(anchor, swiperContainer);
  
  // Move the swiper container inside the anchor
  anchor.appendChild(swiperContainer);
}

function preventNavigationOnControls(swiperContainer) {
  // Prevent anchor navigation when clicking on navigation controls
  const controls = swiperContainer.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination');
  
  controls.forEach(control => {
    control.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
    });
  });
}

function addSwiperStyles() {
  // Check if styles are already added
  if (document.getElementById('product-card-swiper-styles')) return;
  
  const styleSheet = document.createElement('style');
  styleSheet.id = 'product-card-swiper-styles';
  styleSheet.innerHTML = `
    .product-card-swiper-container {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    
    .product-card-swiper-container .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .product-card-swiper-container .swiper-slide img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    
    /* Hide navigation elements by default */
    .product-card-swiper-container .swiper-button-prev,
    .product-card-swiper-container .swiper-button-next,
    .product-card-swiper-container .swiper-pagination {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
      z-index: 20; /* Ensure they're above the anchor */
    }
    
    /* Show navigation elements after initialization */
    .product-card-swiper-container .swiper-nav-initialized {
      visibility: visible;
      opacity: 0; /* Still hidden but now can transition to visible */
    }
    
    .product-card-swiper-container .swiper-button-prev,
    .product-card-swiper-container .swiper-button-next {
      color: var(--color-foreground);
      width: 30px;
      height: 30px;
      z-index: 20; /* Ensure buttons are above slides and anchor */
    }
    
    .product-card-swiper-container .swiper-button-prev:after,
    .product-card-swiper-container .swiper-button-next:after {
      display: none;
    }
    
    .product-card-swiper-container:hover .swiper-button-prev.swiper-nav-initialized,
    .product-card-swiper-container:hover .swiper-button-next.swiper-nav-initialized {
      opacity: 0.8;
    }
    
    .product-card-swiper-container .swiper-pagination {
      position: absolute;
      bottom: 5px;
      z-index: 20; /* Ensure pagination is above slides and anchor */
    }
    
    .product-card-swiper-container .swiper-pagination.swiper-nav-initialized {
      opacity: 1;
    }
    
    .product-card-swiper-container .swiper-pagination-bullet {
      background: var(--color-foreground);
      opacity: 0.5;
    }
    
    .product-card-swiper-container .swiper-pagination-bullet-active {
      opacity: 1;
    }
    
    @media screen and (max-width: 767px) {
      .product-card-swiper-container .swiper-button-prev,
      .product-card-swiper-container .swiper-button-next {
        display: none;
      }
    }
    
    @media screen and (min-width: 768px) {
      .product-card-swiper-container .swiper-pagination {
        display: none;
      }
    }
  `;
  
  document.head.appendChild(styleSheet);
}
